import { useCallback, useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { SURVEYS_COLUMNS } from '../../../../constants/reports';
import { getTextWidthInOneLine } from '../../../../utils/strings';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportSurveys({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: applyExcelFormats(value, SURVEYS_COLUMNS[key]?.style?.numFmt),
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const getRowHeight = useCallback(
    index => {
      const questionWidthInOneLine = getTextWidthInOneLine(formattedReport[index].questionText);
      const answerWidthInOneLine = getTextWidthInOneLine(formattedReport[index].answerText);

      return Math.max(
        questionWidthInOneLine > 36 * 6 - 16
          ? Math.ceil((questionWidthInOneLine / (36 * 6)) * 20) + 36
          : 0,
        answerWidthInOneLine > 32 * 6 - 16
          ? Math.ceil((answerWidthInOneLine / (32 * 6)) * 20) + 36
          : 0,
        36,
      );
    },
    [formattedReport],
  );

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={SURVEYS_COLUMNS}
        headerHeight={36}
        getRowHeight={getRowHeight}
        rowKey="uuid"
      />
    </>
  );
}

export default ReportSurveys;
